import { __assign, __read, __rest } from "tslib";
import React, { useState, useRef, useEffect } from 'react';
import { formatValue as valueFormatter, } from '@keen.io/charts-utils';
import { MAX_VALUE_PLACEHOLDER } from './constants';
var GaugeLabels = function (_a) {
    var arcPath = _a.arcPath, minValue = _a.minValue, maxValue = _a.maxValue, typography = _a.typography, formatValue = _a.formatValue;
    var _b = __read(useState(null), 2), rect = _b[0], setRect = _b[1];
    var element = useRef(null);
    useEffect(function () {
        var bbox = element.current.getBBox();
        setRect(bbox);
    }, []);
    var fontColor = typography.fontColor, textProps = __rest(typography, ["fontColor"]);
    var textStyle = __assign({ transform: "translateY(" + (textProps.fontSize + 10) + "px)", fill: fontColor }, textProps);
    var minimum = minValue === 'auto' ? 0 : minValue;
    var minLabel = formatValue ? valueFormatter(minimum, formatValue) : minimum;
    var maxLabel = typeof maxValue !== 'number'
        ? MAX_VALUE_PLACEHOLDER
        : formatValue
            ? valueFormatter(maxValue, formatValue)
            : maxValue;
    return (React.createElement("g", null,
        React.createElement("path", { ref: element, fill: "transparent", d: arcPath }),
        rect && (React.createElement(React.Fragment, null,
            React.createElement("text", { textAnchor: "middle", style: textStyle, x: rect.x, y: rect.y }, minLabel),
            React.createElement("text", { textAnchor: "middle", style: textStyle, x: rect.x + rect.width, y: rect.y }, maxLabel)))));
};
export default GaugeLabels;
